import BannerComponent from "slotworks/components/banner/banner-component";
import Components from "slotworks/components/components";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import Layers from "slotworks/graphics/layers/layers";
import ExtendedSpine from "slotworks/graphics/spine/spine";
import deviceInfo from "slotworks/utils/device-info";

export default class HarleyBannerComponent extends BannerComponent {

    private layer: Layers;

    private spine: ExtendedSpine;

    constructor() {
        super();
        BannerComponent.loopTime = Infinity;
        
        for (const mode of Object.keys(Components.config.banner)) {
            this.addScenesForMode(mode, Components.config.banner[mode]);
        }

        this.layer = Layers.Banners;
        this.layer.onSceneEnter.add(this.init);
        deviceInfo.onLayoutChange.add(() => this.init(), 1);

        this.init();

        Components.matrix.startSignal.add(this.spinStart);
        HarleyBannerComponent.loopTime = Infinity;
    }

    public win() {
        if(this.spine.name === "harley_quickWin_title") {
            this.spine.play(1, "win", false);
        } else {
            this.spine.play(1, "Win", false);
        }
    }

    private init = () => {
        this.spine = this.layer.getSpine("harley_quickWin_title");
        if(this.spine) { // problem with spine positioning            
            if(deviceInfo.widePortrait && canvasManager.orientation === Orientation.PORTRAIT) {
                this.spine.setSkin("B");
                this.spine.scale.x = 0.85;
                this.spine.scale.y = 0.85;                
            } else {
                this.spine.setSkin("A");
            }
            this.spinStart();
        } else {
            this.spine = this.layer.getSpine("freespinslogo");            
            // screen/landscape
            // screen/portrait_3x4
            // screen/portrait_9x16
            if(deviceInfo.isDesktop || canvasManager.orientation === Orientation.LANDSCAPE) {
                this.spine.play(0, "screen/landscape", false);
            } else if (deviceInfo.widePortrait) {
                this.spine.play(0, "screen/portrait_3x4", false);
            } else {
                this.spine.play(0, "screen/portrait_9x16", false);
            }
        }
    }

    private spinStart = () => {
        this.spine.play(1, "idle", false);
        const image = this.layer.getSprite("Main_title") || this.layer.getSprite("Freespins_title");
        image.visible = false;
    }
    
    

    // spine-freespinslogo
    // Freespins_title

    // spine-harley_quickWin_title
    // Main_title, idle, idle1, win
    // default, 'A', 'B', 'C'

    // Freespins_title

}